<template>
  <v-app>
    <v-row class="justify-center ma-0">
      <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
        <p>Carregando...</p>
        <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
      </div>
      <v-col
        class="col-12 col-sm-12 col-md-11 col-lg-11"
        v-if="!isLoading"
        :class="{ 'pt-3': $vuetify.breakpoint.smAndDown, 'pt-5': $vuetify.breakpoint.mdAndUp }"
      >
        <v-container>
          <v-row class="justify-center" v-if="category == 'patient' && isProfileIncomplete">
            <v-col class="col-12">
              <v-alert type="warning" border="left" colored-border elevation="1">
                Seu perfil está incompleto. Por favor,
                <router-link to="edit-profile">complete seus dados</router-link>
                para aproveitar todos os recursos da plataforma.
              </v-alert>
            </v-col>
          </v-row>
          <v-row
            class="justify-center align-center flex-column flex-md-row my-2"
            v-if="category == 'patient'"
          >
            <v-col class="col-12 col-md-5">
              <h2 class="mx-2 text-center text-md-left">Perfil</h2>
            </v-col>
            <v-col class="col-12 col-md-5">
              <v-row
                :class="{
                  'justify-space-around': $vuetify.breakpoint.smAndDown,
                  'justify-end': $vuetify.breakpoint.mdAndUp,
                }"
              >
                <v-btn
                  color="gray"
                  to="/change-password"
                  dark
                  :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }"
                  >{{ $t('pageProfile.btnSenha') }}</v-btn
                >
                <v-btn color="gray" to="edit-profile" dark>Editar Perfil</v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col class="col-12 col-md-5 col-lg-5 px-2">
              <v-col class="col-12 d-flex align-center justify-end">
                <div
                  class="pl-12"
                  style="
                    background: #fffde3;
                    padding: 13px 0;
                    border-radius: 12px;
                    width: calc(100% - 46px);
                    position: relative;
                  "
                >
                  <div style="position: absolute; left: -50px; top: 0">
                    <v-avatar size="90">
                      <v-img v-if="user.photo != '' && user.photo != null" :src="user.photo">
                        <template v-slot:placeholder>
                          <v-row fill-height align-center justify-center ma-0>
                            <v-progress-circular
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <v-img
                        v-if="(user.photo == '') | (user.photo == null)"
                        :src="require('../../assets/no-image.png')"
                      ></v-img>
                    </v-avatar>
                  </div>
                  <p class="mb-2 font-weight-bold subheading">{{ user.name }}</p>
                  <p class="ma-0">
                    <span class="font-weight-bold">Nacionalidade: </span>{{ user.country }}
                  </p>
                </div>
              </v-col>
              <div class="d-flex mt-4">
                <v-col class="col-6 ml-2">
                  <p><span class="font-weight-bold">Sexo: </span>{{ user.gender }}</p>
                </v-col>
                <v-col class="col-6">
                  <p><span class="font-weight-bold">Nascimento: </span>{{ user.date_birth }}</p>
                </v-col>
              </div>
              <v-divider></v-divider>
              <div class="d-flex mt-4">
                <v-col class="col-6 ml-2">
                  <p>
                    <span class="font-weight-bold">{{ $t('pageProfile.labelDestrito') }}: </span
                    >{{ user.state }}
                  </p>
                </v-col>
                <v-col class="col-6">
                  <p><span class="font-weight-bold">Cidade: </span>{{ user.city }}</p>
                </v-col>
              </div>
              <v-divider></v-divider>
              <div>
                <h3 class="my-4">{{ $t('pageProfile.titleContato') }}</h3>
                <div>
                  <div class="mb-3 box-contact d-flex align-center" v-if="user.telephone">
                    <span> Telefone </span>
                    <v-img
                      :src="require('../../assets/icon-call.svg')"
                      width="28px"
                      class="mx-2"
                    ></v-img>
                    <p>{{ user.telephone }}</p>
                  </div>
                  <div class="mb-3 box-contact d-flex align-center" v-if="user.whatsapp">
                    <span> WhatsApp </span>
                    <v-img
                      :src="require('../../assets/logo-whatsapp.svg')"
                      width="28px"
                      class="mx-2"
                    ></v-img>
                    <p>{{ user.whatsapp }}</p>
                  </div>
                  <div class="mb-3 box-contact d-flex align-center" v-if="user.hangouts">
                    <span> Hangouts </span>
                    <v-img
                      :src="require('../../assets/icon-hangout.svg')"
                      width="28px"
                      class="mx-2"
                    ></v-img>
                    <p>{{ user.hangouts }}</p>
                  </div>
                  <div class="mb-3 box-contact d-flex align-center" v-if="user.messenger">
                    <span> Messenger </span>
                    <v-img
                      :src="require('../../assets/icon-messenger.svg')"
                      width="28px"
                      class="mx-2"
                    ></v-img>
                    <p>{{ user.messenger }}</p>
                  </div>
                  <div class="mb-3 box-contact d-flex align-center" v-if="user.skype">
                    <span> Skype </span>
                    <v-img
                      :src="require('../../assets/logo-skype.svg')"
                      width="28px"
                      class="mx-2"
                    ></v-img>
                    <p>{{ user.skype }}</p>
                  </div>
                  <div class="mb-3 box-contact d-flex align-center" v-if="user.email">
                    <span> Email </span>
                    <v-img
                      :src="require('../../assets/icon-mail.svg')"
                      width="28px"
                      class="mx-2"
                    ></v-img>
                    <p>{{ user.email }}</p>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col class="col-12 col-md-5 col-lg-5 px-2 ml-md-4">
              <div>
                <h3>{{ $t('pageProfile.titleEmergencia') }}</h3>
                <div class="d-flex mt-4">
                  <v-col xs10 ml-2>
                    <p><span class="font-weight-bold">Nome: </span>{{ user.contact_name }}</p>
                  </v-col>
                </div>
                <v-divider></v-divider>

                <div class="d-flex mt-4">
                  <v-col xs10 ml-2>
                    <p>
                      <span class="font-weight-bold">Telefone: </span>{{ user.contact_telephone }}
                    </p>
                  </v-col>
                </div>
                <v-divider></v-divider>

                <div class="d-flex mt-4">
                  <v-col xs10 ml-2>
                    <p><span class="font-weight-bold">Email: </span>{{ user.contact_email }}</p>
                  </v-col>
                </div>
                <v-divider></v-divider>
              </div>
              <div class="my-4" v-if="category == 'psychologist'">
                <h3>Prontuário</h3>
                <div class="d-flex flex-column my-4">
                  <v-textarea
                    solo
                    flat
                    no-resize
                    label="Prontuário"
                    v-model="record"
                    background-color="#F7F7F7"
                  ></v-textarea>
                  <v-btn
                    color="primary"
                    class="white--text align-self-center"
                    :disabled="isDisabled"
                    :loading="isSave"
                    @click="saveRecords()"
                    >Salvar</v-btn
                  >
                </div>
                <div>
                  <v-card
                    class="mx-auto my-3"
                    outlined
                    v-for="(item, index) in records"
                    :key="index"
                  >
                    <v-card-title>{{ item.date | formatDateTime }}</v-card-title>
                    <v-card-text>{{ item.comments }}</v-card-text>
                  </v-card>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <!-- <v-row row justify-center my-3>
            <v-btn large  color="primary" @click="getOut">
                <v-icon left dark>exit_to_app</v-icon>
                Sair
            </v-btn>
        </v-row> -->
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
import Api from '../../services/httpClient';
import moment from 'moment-timezone';

export default {
  data: () => ({
    user: {
      photo: '',
      name: '',
      country: '',
      gender: '',
      date_birth: '',
      state: '',
      city: '',
      whatsapp: '',
      hangouts: '',
      skype: '',
      messenger: '',
      email: '',
      contact_name: '',
      contact_email: '',
      contact_telephone: '',
    },
    records: {},
    record: '',
    cod: '',
    codPsi: '',
    isLoading: false,
    isDisabled: true,
    isSave: false,
    category: 'patient',
  }),
  async created() {
    await this.getCod();
    await this.getUser();
    if (this.category == 'psychologist') {
      this.getRecords();
    }
  },
  computed: {
    isProfileIncomplete() {
      const requiredFields = [
        'name',
        'gender',
        'date_birth',
        'telephone',
        'email',
        'country',
        'city',
        'state',
        'contact_name',
        'contact_telephone',
        'contact_email',
      ];
      return requiredFields.some((field) => !this.user[field]);
    },
  },
  watch: {
    record(val) {
      val != '' ? (this.isDisabled = false) : (this.isDisabled = true);
    },
  },
  methods: {
    getUser: function () {
      this.isLoading = true;
      Api.get(`/patients/${this.cod}/`, {
        headers: { Authorization: `Token ${localStorage.getItem('user-token')}` },
      })
        .then((response) => {
          this.user = response.data;
          this.formatData(this.user.date_birth);
          console.log(this.user);
        })
        .catch((err) => {
          console.log(err.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    formatData(v) {
      this.user.date_birth = !v ? '' : moment(v).format('DD/MM/YYYY');
    },

    getCod() {
      this.category = localStorage.getItem('user-category');
      if (this.category == 'patient') {
        this.cod = localStorage.getItem('user-id');
      } else {
        this.cod = this.$route.params.id;
        this.codPsi = localStorage.getItem('user-id');
      }
    },

    getOut() {
      localStorage.clear();
      this.$router.replace('/paciente/login');
    },

    async saveRecords() {
      try {
        const { data, status } = await Api.post(
          `/psychologists/${this.codPsi}/patients/${this.cod}/records/`,
          {
            comments: this.record,
          },
          {
            headers: { Authorization: `Token ${localStorage.getItem('user-token')}` },
          },
        );

        if (status == 201) {
          this.getRecords();
          this.record = '';
        } else {
          console.log('Ocorreu um erro ao salvar o prontuario!');
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getRecords() {
      try {
        this.isSave = true;

        const { data, status } = await Api.get(
          `/psychologists/${this.codPsi}/patients/${this.cod}/records/`,
          {
            headers: { Authorization: `Token ${localStorage.getItem('user-token')}` },
          },
        );
        if (status == 200) {
          this.records = data.records;
          console.log(this.records);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isSave = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.box-contact
    background-color: #F7F7F7
    padding: 16px
    color: #6F6F6F
    font-size: 18px
    flex-wrap: wrap

    > *
      flex: 0 0 auto !important

    p
      margin: 0

    span
      margin-right: 10px
      font-weight: bold
h2
  color: var(--v-primary-base)
</style>
